export const ru = {
  // Menu
  menuTitle: "Меню",

  // Tabs
  tabAugment: "ЛС",
  tabSkill: "Скиллы",
  tabEnchant: "Точка вещей",
  tabWeapon: "Оружие",
  tabEquipment: "Сравнить",
  tabSimulator: "Симулятор",
  
  // Augment Panel
  augmentConfig: "НАСТРОЙКИ",
  desiredSkills: "Подойдет скиллов (из 178)",
  lifeStones: "В ИНВЕНТАРЕ",
  stoneLife: "Life",
  stoneMid: "Mid",
  stoneTop: "Top",
  stoneUltimate: "Ult",
  successProbability: "Повезет с шансом",
  probabilityOfSuccess: "Шанс поймать хотя бы 1 из {n}:",
  probabilityOfSpecificSuccess: "Шанс получить один скилл:",
  withCurrentStones: "с текущими камнями",
  withTotalAugmentations: "с",
  totalAugmentation: "попыткой",
  totalAugmentationsPlural: "попытками",
  lifeStonePrice: "Цена Life Stone (в адене)",
  topGradePrice: "Цена Top-Grade Life Stone (в адене)",
  priceSettings: "Цены",
  
  // Augment Analysis
  analysis: "АНАЛИЗ",
  singleAugmentSuccess: "Шанс успеха за 1 попытку",
  expectedAttemptsNeeded: "В среднем попыток",
  expectedCostAdena: "Средняя стоимость (адена)",
  skillChance1: "1% шанс на скилл",
  skillChance6: "6% шанс на скилл",
  skillChance25: "25% шанс на скилл",
  skillChance100: "100% шанс на скилл",
  stoneLife: "Life",
  stoneMid: "Mid",
  stoneTop: "Top",
  stoneUltimate: "Ultimate",
  
  // Skill Enchant Panel
  skillEnchantMastery: "Skill Enchant Mastery",
  masteryNone: "Нет",
  targetEnchantLevel: "ЦЕЛЬ",
  alreadyEnchanted: "Уже точен",
  currentLevel: "Текущий уровень",
  safeLevels: "Безопасные:",
  enchantChances: "ШАНСЫ",
  enchantChancesHint: "📖 = нужна книга · Зелёный = безопасный",
  expectedCostSummary: "Ожидаемые затраты +{currentLevel} → +{targetLevel}",
  booksGuaranteed: "Книг понадобится (минимум)",
  expectedAttempts: "В среднем попыток",
  expectedBooks: "В среднем книг",
  expectedBooksCost: "Общая стоимость книг",
  masterySavesPerSkill: "Экономия на скилл",
  masteryOneTimeCost: "Стоимость мастери (разово)",
  masteryBreakEvenVsNone: "vs Нет",
  masteryBreakEvenVsPrev: "vs",
  afterSkills: "{n} скиллов",
  paysOffNow: "1 скилл",
  books: "книг",
  enchantBookPrice: "Цена книги гигантов (в адене)",
  ancientAdenaPrice: "Цена Ancient Adena (в адене)",
  
  // Enchant Panel
  configuration: "НАСТРОЙКИ",
  enchantChancesTitle: "ШАНСЫ",
  expectedAttemptsTitle: "В СРЕДНЕМ",
  regularScrolls: "Обычные точки",
  itemsNeeded: "вещей понадобится",
  blessedScrolls: "Блески",
  prices: "ЦЕНЫ",
  itemPrice: "Цена вещи",
  regularScrollPrice: "Цена точки",
  blessedScrollPrice: "Цена блески",
  expectedCostComparison: "СРАВНЕНИЕ СТОИМОСТИ",
  regularCost: "Обычные (точки + лом вещей)",
  blessedCost: "Блески",
  recommendation: "Рекомендация",
  recBlessed: "Блески",
  recRegular: "Обычные",
  viewCostPerLevel: "По уровням",
  hide: "Скрыть",
  levelCol: "Ур.",
  scrollsCol: "Количество",
  regularCol: "Обычные",
  blessedCol: "Блески",
  
  // Simulator Panel
  sim_instruction: "Выберите камень и нажмите Аугментировать",
  sim_success: "Аугментация успешна!",
  sim_loading: "Загрузка звуков...",
  sim_augmenting: "Аугментация...",
  sim_augment_btn: "Инкрустировать",
  sim_used: "Потрачено",
  sim_skill_rate: "Скилл %",
  sim_best: "Лучшая серия",
  sim_worst: "Худшая серия",
  sim_history: "ПОСЛЕДНИЕ АУГМЕНТАЦИИ",
  sim_mute: "Выключить звук",
  sim_unmute: "Включить звук",

  // Equipment Panel
  equip_weapon: "Оружие",
  equip_armor: "Броня",
  equip_jewelry: "Бижутерия",
  weaponType: "ТИП ОРУЖИЯ",
  armorType: "ТИП БРОНИ",
  myWeapon: "МОЁ ОРУЖИЕ",
  myArmor: "МОЙ КОМПЛЕКТ БРОНИ",
  myJewelrySet: "МОЙ КОМПЛЕКТ БИЖУТЕРИИ",
  myJewelryPiece: "МОЯ БИЖУТЕРИЯ",
  compareTo: "СРАВНИТЬ С",
  crossoverAt: "Догонит на",
  diffAt: "Разн. @+{n}",
  enchantLevel: "Заточка",
  jewelry_sets: "Комплекты",
  jewelry_individual: "По штукам",
  jewelry_necklace: "Ожерелье",
  jewelry_earring: "Серьга",
  jewelry_ring: "Кольцо",
  jewelryPieceType: "ТИП ПРЕДМЕТА",
  armor_heavy: "Тяж.",
  armor_light: "Лёгкая",
  armor_robe: "Роба",
  weapon_sword: "Меч",
  weapon_blunt: "Дубина",
  weapon_dagger: "Кинжал",
  weapon_pike: "Копьё",
  weapon_fist: "Кулаки",
  weapon_dual: "Парные",
  weapon_bow: "Лук",
  weapon_mage: "Магич.",
  hideBreakdown: "Скрыть таблицу",
  viewAllLevels: "Показать полную таблицу",

  // Wiki Panel
  tabWiki: "База знаний",
  wikiSection_events: "Ивенты",
  wikiSection_marks: "Марки",

  // Events Schedule
  eventsServerTime: "Время сервера",
  eventsLocalTime: "Местное время",
  eventsYourTime: "Местное",
  eventsServerTimeHeader: "Сервер",
  eventsEventName: "Ивент",
  eventsRecentPast: "Прошедшие",
  eventsNow: "СЕЙЧАС",
  eventsToday: "Сегодня",
  eventsTomorrow: "Завтра",
  eventsNote: "Время указано по серверу (GMT+3) и в вашем часовом поясе. Расписание обновляется каждую минуту.",
  wikiMarksIntro: "Марки дают случайные статы на +5, +7, +9. Статы 1 тира удваиваются на +6 и снова на +8. Статы 2 тира удваиваются на +8. На +10 фиксированный стат.",
  wikiStatName: "Стат",
  wikiMarkNote: "Один случайный стат на тир. 1 тир также удваивается на +8.",
  wikiFixedStat: "фикс.",
  wikiPlain: "Mark",
  wikiEnchantBonuses: "Бонусы заточки",
  wikiAllStats: "все статы",
  wikiRandomStat: "один случ.",
  wikiMark_avadon: "Mark of Avadon",
  wikiMark_speed: "Mark of Speed",
  wikiMark_hunter: "Mark of Hunter",
  wikiMark_defender: "Mark of Defender",
  wikiMark_divine: "Mark of Divine",
  wikiMark_doom: "Mark of Doom",
  wikiMark_immunity: "Mark of Immunity",
  wikiMark_power: "Mark of Power",
  wikiMark_blood: "Mark of Blood",
  
  // Keyboard
  done: "Готово"
};
